
import { computed, defineComponent, onMounted, ref, watch } from 'vue';
import { useStudent } from '@/features/student/useStudent';
import { useRoute, useRouter } from 'vue-router';
import { _ROUTER_NAME } from '@/enums';
import Multiselect from '@suadelabs/vue3-multiselect';
import PlanFutureSlideOver from '@/components/modules/reportTargetFuture/PlanFutureSlideOver.vue';

export default defineComponent({
	name: 'CreateGoalsFuture',
	components: {
		PlanFutureSlideOver,
		Multiselect,
	},
	setup() {
		const id = ref('');
		const router = useRouter();
		const student: any = ref(null);
		const isSlideOpen = ref(true);
		const isUpdated = ref(false);
		const tab = ref({
			label: '',
			value: '',
		} as any);
		const tabs = ref([
			{
				label: 'Mục tiêu mới',
				value: 'plans_report_detail__goal_create_future__create',
			},
			{
				label: 'Mục tiêu tạm dừng',
				value: 'plans_report_detail__goal_create_future__create_by_stop',
			},
			{
				label: 'Ngân hàng mục tiêu',
				value: 'plans_report_detail__goal_create_future__create_by_bank',
			},
		]);
		const route = useRoute();
		id.value = route.params.id ? route.params.id + '' : '';
		const { getStudent } = useStudent();

		watch(route, () => {
			const name = route?.name;
			tab.value = tabs.value.find((item) => item.value == name);
		});

		watch(tab, (value: { value: string }) => {
			if (value) {
				router.push({ name: value.value });
			}
		});

		onMounted(() => {
			const name = route?.name;
			tab.value = tabs.value.find((item) => item.value == name);

			isSlideOpen.value = window.screen.width >= 1024;

			window.scrollTo(0, 0);
		});

		async function fetchStudent() {
			const res = await getStudent(id.value);
			if (res?.data) {
				student.value = res?.data;
			}
		}

		fetchStudent();

		function back() {
			router.push(`/plans/${id.value}`);
		}

		const isCompleted = ref(true);

		function openKHDK() {
			isSlideOpen.value = true;
			isCompleted.value = true;
			isUpdated.value = false;
		}

		function openMTHT() {
			isSlideOpen.value = true;
			isCompleted.value = false;
			isUpdated.value = false;
		}

		function onUpdated() {
			isUpdated.value = true;
		}

		return {
			isUpdated,
			openKHDK,
			openMTHT,
			isCompleted,
			isSlideOpen,
			tab,
			tabs,
			student,
			routerName: computed(() => _ROUTER_NAME),
			back,
			onUpdated,
		};
	},
});
